import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat',
  standalone: false,
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: number): string {
    return value?.toFixed(1);
  }
}
